import React, { useEffect, useState } from 'react';
import Group from 'modules/shared/Forms/Group';
import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { format } from 'date-fns';

import BookingHelper from 'modules/shared/BookingTable/utils';
import styles from './DateTimePicker.module.scss';

type Props = {
  name: string;
  isDisabled?: boolean;
  label: string;
};

const DateTimePickerEvo: React.FC<Props> = ({ name, isDisabled = false, label }) => {
  const formik = useFormikContext();
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');

  const { values, setFieldValue } = formik;

  const handleTimeChange = (e: any) => {
    if (e?.target?.value) {
      const newDateTime = `${date} ${e?.target?.value}`;
      setTime(e.target.value);
      setFieldValue(name, newDateTime);
    }
  };

  const handleDateChange = (e: any) => {
    if (e?.target?.value) {
      const newDateTime = `${e?.target?.value} ${time} `;
      setDate(e.target.value);
      setFieldValue(name, newDateTime);
    }
  };

  useEffect(() => {
    if (name && values) {
      // @ts-ignore
      const dt = values[name] ? new Date(values[name]) : new Date();
      const dateFormat = format(dt, 'yyyy-MM-dd');
      const timeFormat = BookingHelper.formatTime(dt);

      setTime(timeFormat);
      setDate(dateFormat);
      // @ts-ignore
      if (!values[name]) {
        // @ts-ignore
        values[name] = dt;
      }
    }
  }, [name]);

  return (
    <Group label={label} isInvalid={false} name={name}>
      <div className={classNames(styles.dateTimePickerEvoContainer)}>
        <div className={styles.dateTimePickerEvo}>
          <input
            type="date"
            onChange={handleDateChange}
            className={styles.inputDateEvo}
            value={date}
            disabled={isDisabled}
          />
          <input
            type="time"
            value={time}
            className={styles.inputTimeEvo}
            onChange={handleTimeChange}
            disabled={isDisabled}
          />
        </div>
      </div>
    </Group>
  );
};

export default DateTimePickerEvo;
